import React from 'react';

import WantedAd from './wantedAdd';
import PostAd from './postAd';

interface MyAdvertismentProps {
  app: 'farm' | 'wholesaler';

  isSaleAD: boolean;
}
const MyAdvertisment = ({isSaleAD, app}: MyAdvertismentProps) => {
  return (
    <>
      {!isSaleAD ? (
        <PostAd type="post" app={app} />
      ) : (
        <WantedAd type="wanted-post" app={app} />
      )}
    </>
  );
};

export default MyAdvertisment;
